<div class="dtf-dashboard">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


  <div *ngIf="(this.bodyLoaded)" class="mbfs-payoff-quote-spinner">

    <!--Default page to load while waiting for Redirection to Classic-->
    <section class="mbfs-home-hero"
      style="background-image: url(/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg);">
      <section class="mbfs-home-hero__header">
        <h2 class="mbfs-home-hero__header-subtitle">
          {{ 'LoaderPages.BannerHeader' | translate }}
        </h2>
        <p class="mbfs-home-hero__header-text-demi">
          {{ 'LoaderPages.Loading' | translate }}
        </p>

        <!--Spinner-->
        <div class="mbfs-loading-spinner-overlay"></div>
        <div class="mbfs-loading-spinner"> </div>
      </section>
    </section>
  </div>

  <!--US HTML page-->
  <div class="container_dashboard" *ngIf="!this.bodyLoaded  && !isCanadaPortal">
    <h4 class="dtfbrochures__header_dark">{{ 'DocumentCenter.Header' | translate }}</h4>
    <div class="dtfbrochures__containerlong" *ngIf="!isTerminatedAccounts">
      <div class="row4">
        <div class="dynamicflexbox">
          <section class="section">
            <div class="section__item section__item--start">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
              <h3 class="dtfbrochures__header6">{{this.recAccCount}}</h3>
            </div>
            <div class="section__item section__item--end">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
              <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3>
            </div>
          </section>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <h4 class="dtfbrochures__title">{{ 'DocumentCenter.YearlyHeader' | translate }}</h4>
            <div class="row">
              <img class="iconimage1" src="static/assets/img/dtf-assets/images/redesign/Year-End_letter-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'DocumentCenter.YearlySubHeader' | translate }}</h4>
            </div>
            <div class="row2">
              <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                [(ngModel)]="selectedYear">
                <mat-radio-button class="example-radio-button" *ngFor="let year of years" [value]="year">
                  {{year}}
                </mat-radio-button>
              </mat-radio-group>
              <button class="mbfs-button" [disabled]="!selectedYear" (click)="retrieveInterestLetter(selectedYear)">{{
                'DocumentCenter.Download' | translate }}</button>
              <div *ngIf="!tableLoaded">
                <h5 class="mbfs-modal-error">{{'Invoice.Loading1' | translate}}<br></h5>
              </div>
              <div *ngIf="!ShowYIL">
                <h5 class="mbfs-modal-error">{{this.InterestserviceErrorDesc}}<br></h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <h4 class="dtfbrochures__title">{{ 'DocumentCenter.InvoiceHeader' | translate }}</h4>
            <div class="row">
              <img class="iconimage1" src="static/assets/img/dtf-assets/images/redesign/View-Your-Invoices-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'DocumentCenter.InvoiceHeader' | translate }}</h4>
            </div>
         <div class="row2">
              <div class="test2">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Invoice.DateRange' | translate }} </mat-label>
                  <mat-date-range-input [min]="minDate" [max]="currentDate" [rangePicker]="dateRangePicker">
                    <input matStartDate readonly [(ngModel)]="dateRangeStart"/>
                    <input matEndDate readonly [(ngModel)]="dateRangeEnd" (dateChange)="dateRangeChange()" />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="dateRangePicker">
                  </mat-datepicker-toggle>
                  <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
                </mat-form-field>
              </div>
              <div class ="test2">
                <span style="float: left;margin-right: 10px;margin-top: 10px;">OR</span>
                <mat-form-field appearance="outline">
                  <mat-select name="statementPeriod" placeholder="{{ 'Invoice.StatePeriod' | translate }}" (selectionChange)="onStatementChange()" [(ngModel)]="selectedMonth">
                    <mat-option *ngFor="let month of statementMonths" [value]="month.value">
                      {{ month.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <button type="submit" (click)="checkUrl('invoice')" class="mbfs-button">{{ 'Invoice.Search' | translate }}</button>
              </div>
              <br>
            </div>
            <!-- <div class="row2">
            <button type="submit" (click)="checkUrl('invoice')" class="mbfs-button">{{ 'Invoice.Search' | translate }}</button>
            </div>  -->
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <h4 class="dtfbrochures__title">{{ 'DocumentCenter.ContactCopy' | translate }}</h4>
            <div class="row">
              <img class="iconimage1" src="static/assets/img/dtf-assets/images/redesign/Doc-Request-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'DocumentCenter.ComingSoon1' | translate }}</h4>
            </div>
            <div class="row2">
              <!-- <p class="dtfbrochures__paragraph1">{{ 'DocumentCenter.ComingSoon1Paragraph' | translate }}</p> -->
              <div class ="test2">
                <mat-form-field appearance="outline">
                  <mat-select name="statementPeriod" placeholder="{{ 'DocumentCenter.SelectRequest' | translate }}" (selectionChange)="onStatementChange()" [(ngModel)]="selectedRequest">
                    <mat-option *ngFor="let request of selectedRequests" [value]="request.value">
                      {{request.viewValue }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <button type="submit" (click)="checkUrl('docrequest')" class="mbfs-button">{{ 'Invoice.SelectDocument' | translate }}</button>
              </div>
            </div>
            <br>
            <br>
            <br>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <h4 class="dtfbrochures__title">{{ 'DocumentCenter.TitleCopy' | translate }}</h4>
            <div class="row">
              <img class="iconimage1" src="static/assets/img/dtf-assets/images/redesign/Title-Copy-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'DocumentCenter.TitleCopy' | translate }}</h4>
            </div>
            <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'DocumentCenter.TitleCopyParagraph' | translate }}</p>
              <mat-form-field appearance="outline">
                <mat-select name="account" placeholder="{{ 'AccountDetails.Search' | translate }}"
                  [(ngModel)]="selectedTitle">
                  <mat-option *ngFor="let account of accountDetailsRes" [value]="account.contractNum">
                    {{account.contractNum}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <button class="mbfs-button" [disabled]="!selectedTitle" (click)="getDocumentList('Title')">{{
                'DocumentCenter.Download' | translate }}</button>
              <div *ngIf="!tableLoaded1">
                <h5 class="mbfs-modal-error">{{'Invoice.Loading' | translate}}<br></h5>
              </div>
              <div *ngIf="this.TitleOccurred">
                <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
              </div>
            </div>

            <!-- <img src="{{ contractdata }}" *ngIf="contractdata" alt="Download file" style="display: block;" /> -->

            <!-- <div class="row2"> -->
            <!--Error Display to Modal View-->
            <!-- <div  *ngIf="this.TitleOccurred">
              <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
            </div> -->

            <!--Spinner on Login Load-->
            <!-- <div *ngIf="(!this.titleLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                  <div class="mbfs-loading-spinner-overlay"></div>
                  <div class="mbfs-loading-spinner"> </div>
            </div> -->
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>

 <div class="dtfbrochures__containerlong" *ngIf="!isTerminatedAccounts">
  <h4 class="dtfbrochures__title">{{ 'LoginHeader.StatetoStateTransfer' | translate }}</h4>
  <div class="row">
    <img class="iconimage1" src="static/assets/img/dtf-assets/images/redesign/Title-State-to-State-Transfer-Icon.png">
    <h4 class="dtfbrochures__header3">{{ 'LoginHeader.StatetoStateTransfer' | translate }}</h4>
  </div>
     <div class="row3">
      <p class="dtfbrochures__paragraph1">{{ 'DocumentCenter.TitleTransferTitle' | translate }}</p>
      <button style="float: right;" type="submit" (click)="checkUrl('title state transfer')" class="mbfs-button">{{ 'DocumentCenter.Begin' | translate }}</button>
    </div>
     <br><br>
   </div>
  </div>
   <!--CA HTML page-->
   <div class="container_dashboard" *ngIf="!this.bodyLoaded  && isCanadaPortal">
    <h4 class="dtfbrochures__header_dark">{{ 'DocumentCenter.Header' | translate }}</h4>
    <div class="dtfbrochures__containerlong" *ngIf="!isTerminatedAccounts">
      <div class="row4">
        <div class="dynamicflexbox">
          <section class="section">
            <div class="section__item section__item--start">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
              <h3 class="dtfbrochures__header6">{{this.recAccCount}}</h3>
            </div>
            <div class="section__item section__item--end">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
              <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <h4 class="dtfbrochures__title">{{ 'DocumentCenter.YearlyHeader' | translate }}</h4>
            <div class="row">
              <img class="iconimage1" src="static/assets/img/dtf-assets/images/redesign/Year-End_letter-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'DocumentCenter.YearlySubHeader' | translate }}</h4>
            </div>
            <div class="row2">
              <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                [(ngModel)]="selectedYear">
                <mat-radio-button class="example-radio-button" *ngFor="let year of years" [value]="year">
                  {{year}}
                </mat-radio-button>
              </mat-radio-group>
              <!-- <div>Your favorite season is: {{selectedYear}}</div> -->
              <button class="mbfs-button" [disabled]="!selectedYear" (click)="retrieveInterestLetter(selectedYear)">{{
                'DocumentCenter.Download' | translate }}</button>
              <div *ngIf="!tableLoaded">
                <h5 class="mbfs-modal-error">{{'Invoice.Loading1' | translate}}<br></h5>
              </div>
              <div *ngIf="!this.InterestFound">
                <h5 class="mbfs-modal-error">{{this.InterestserviceErrorDesc}}<br></h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <h4 class="dtfbrochures__title">{{ 'DocumentCenter.InvoiceHeader' | translate }}</h4>
            <div class="row">
              <img class="iconimage1" src="static/assets/img/dtf-assets/images/redesign/View-Your-Invoices-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'DocumentCenter.InvoiceHeader' | translate }}</h4>
            </div>
            <div class="row2">
              <div class="test2">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Invoice.DateRange' | translate }} </mat-label>
                  <mat-date-range-input [min]="minDate" [max]="currentDate" [rangePicker]="dateRangePicker">
                    <input matStartDate readonly [(ngModel)]="dateRangeStart"/>
                    <input matEndDate readonly [(ngModel)]="dateRangeEnd" (dateChange)="dateRangeChange()" />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="dateRangePicker">
                  </mat-datepicker-toggle>
                  <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
                </mat-form-field>
              </div>
              <div class ="test2">
                <span style="float: left;margin-right: 10px;margin-top: 10px;">OR</span>
                <mat-form-field appearance="outline">
                  <mat-select name="statementPeriod" placeholder="{{ 'Invoice.StatePeriod' | translate }}" (selectionChange)="onStatementChange()" [(ngModel)]="selectedMonth">
                    <mat-option *ngFor="let month of statementMonths" [value]="month.value">
                      {{ month.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <button type="submit" (click)="checkUrl('invoice')" class="mbfs-button">{{ 'Invoice.Search' | translate }}</button>
              </div>
            </div>
            <!-- <div class="row2">
              <button type="submit" (click)="checkUrl('invoice')" class="mbfs-button">{{ 'Invoice.Search' | translate }}</button>
            </div>  -->
            <br><br><br>
          </div>
        </div>
      </div>
    </div>



    <div class="row">
      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <h4 class="dtfbrochures__title">{{ 'DocumentCenter.ContactCopy' | translate }}</h4>
            <div class="row">
              <img class="iconimage1" src="static/assets/img/dtf-assets/images/redesign/Doc-Request-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'DocumentCenter.ComingSoon1' | translate }}</h4>
            </div>
            <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'DocumentCenter.ComingSoon1Paragraph' | translate }}</p>
              <div class ="test2" *ngIf="!isFrench">
                <mat-form-field appearance="outline">
                  <mat-select name="statementPeriod" placeholder="{{ 'DocumentCenter.SelectRequest' | translate }}" (selectionChange)="onStatementChange()" [(ngModel)]="selectedRequest">
                    <mat-option *ngFor="let request of selectedRequestsCA" [value]="request.value">
                      {{request.viewValue }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <button type="submit" (click)="checkUrl('docrequest')" class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
              </div>
              <div class ="test2"  *ngIf="isFrench">
                <mat-form-field appearance="outline">
                  <mat-select name="statementPeriod" placeholder="{{ 'DocumentCenter.SelectRequest' | translate }}" (selectionChange)="onStatementChange()" [(ngModel)]="selectedRequest">
                    <mat-option *ngFor="let request of selectedRequestsFR" [value]="request.value">
                      {{request.viewValue }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <button type="submit" (click)="checkUrl('docrequest')" class="mbfs-button">{{ 'Invoice.SelectDocument' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="">
          <div class="card-body1">
            <h4 class="dtfbrochures__title">{{ 'DocumentCenter.TitleCopy' | translate }}</h4>
            <div class="row">
              <img class="iconimage1" src="static/assets/img/dtf-assets/images/redesign/Title-Copy-Icon.png">
              <h4 class="dtfbrochures__header3">{{ 'DocumentCenter.ComingSoon2' | translate }}</h4>
            </div>
            <div class="row2">
              <p class="dtfbrochures__paragraph1">{{ 'DocumentCenter.ComingSoon2Paragraph' | translate }}</p>
            <!-- <div class="row2">
              <mat-form-field appearance="outline">
                <mat-select name="account" placeholder="{{ 'AccountDetails.Search' | translate }}"
                  [(ngModel)]="selectedTitle">
                  <mat-option *ngFor="let account of accountDetailsRes" [value]="account.contractNum">
                    {{account.contractNum}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <button class="mbfs-button" [disabled]="!selectedTitle" (click)="getDocumentList('Title')">{{
                'DocumentCenter.Download' | translate }}</button>
              <div *ngIf="this.TitleOccurred">
                <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
              </div>
            </div> -->

            <!-- <img src="{{ contractdata }}" *ngIf="contractdata" alt="Download file" style="display: block;" /> -->

            <!-- <div class="row2"> -->
            <!--Error Display to Modal View-->
            <!-- <div  *ngIf="this.TitleOccurred">
              <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
            </div> -->

            <!--Spinner on Login Load-->
            <!-- <div *ngIf="(!this.titleLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                  <div class="mbfs-loading-spinner-overlay"></div>
                  <div class="mbfs-loading-spinner"> </div>
            </div> -->
            <!-- </div> -->
             <br><br>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  
  